import { 
    MessageResponseDto, 
    GetBillingDto, 
    CreateBillingDto, 
    EditBillingDto,
    BillingControllerGet200Response,
    BillingApiFp,
    DeleteBillingDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseBillingModel = BillingControllerGet200Response;
export type GetBillingModel = GetBillingDto;
export type MutateResponseBillingModel = MessageResponseDto;
export type CreateBillingModel = CreateBillingDto;
export type UpdateBillingModel = EditBillingDto;
export type DeleteBillingModel = DeleteBillingDto;

export const apiBillingFp = BillingApiFp(apiConfig);
export const getBillingController = apiBillingFp.billingControllerGet;
export const createBillingController = apiBillingFp.billingControllerCreate;
export const updateBillingController = apiBillingFp.billingControllerEdit;
export const deleteBillingController = apiBillingFp.billingControllerDelete;

export const QueryKeyBilling = QueryKey.Billing;